module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-decap-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Window Caulking Toronto","short_name":"Window Caulking","description":"Professional window caulking services in Toronto and GTA. We offer residential and commercial caulking for windows, doors, and more. Get a free quote!","lang":"en-CA","start_url":"/","background_color":"#ffffff","theme_color":"#1d4ed8","display":"browser","icon":"static/images/android-chrome-512x512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"15e18725eac11e5ebdbaaecb0ab032a9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
